/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Search_Match_Count_OneInputs */

const en_search_match_count_one = /** @type {(inputs: Search_Match_Count_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} match`)
};

const zh_hans1_search_match_count_one = /** @type {(inputs: Search_Match_Count_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 个匹配`)
};

const pt_br2_search_match_count_one = /** @type {(inputs: Search_Match_Count_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultado`)
};

const es_search_match_count_one = /** @type {(inputs: Search_Match_Count_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} coincidencia`)
};

const fr_search_match_count_one = /** @type {(inputs: Search_Match_Count_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} résultat`)
};

const de_search_match_count_one = /** @type {(inputs: Search_Match_Count_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Treffer`)
};

const ru_search_match_count_one = /** @type {(inputs: Search_Match_Count_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Совпадений: ${i?.count}`)
};

const it_search_match_count_one = /** @type {(inputs: Search_Match_Count_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} risultato`)
};

/**
* | output |
* | --- |
* | "{count} match" |
*
* @param {Search_Match_Count_OneInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_match_count_one = /** @type {((inputs: Search_Match_Count_OneInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Match_Count_OneInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_match_count_one(inputs)
	if (locale === "pt-BR") return pt_br2_search_match_count_one(inputs)
	if (locale === "es") return es_search_match_count_one(inputs)
	if (locale === "fr") return fr_search_match_count_one(inputs)
	if (locale === "de") return de_search_match_count_one(inputs)
	if (locale === "ru") return ru_search_match_count_one(inputs)
	if (locale === "it") return it_search_match_count_one(inputs)
	return en_search_match_count_one(inputs)
});